<div>
  <form (ngSubmit)="approveRequest();">
    <div class="col-12 form-group">
      @if ((data.is_otp_verified == undefined || !data.is_otp_verified) && !isOTPVerified) {
        <div class="kx-control col-6" style="vertical-align: top;">
          <label class="weight" for="" class="required">Enter OTP</label>
          <input type="text" maxlength="10" name="otp" [(ngModel)]="otp" class="form-control" placeholder="enter otp">
          @if (timer > 0) {
            <span class="">Resend OTP
              in <b class="colr">{{timer}}s</b></span>
            }
            @if (timer == 0) {
              <a href="javascript:void(0)"  (click)="authorizationAction();">Resend OTP</a>
            }
          </div>
        }
        <div class="kx-control col-6">
          <label class="weight" for="">Reason</label>
          <textarea placeholder = "Enter Reason" name="reason" [(ngModel)]="reason"  class="form-control" rows="1" maxlength="70">
          </textarea>
        </div>
      </div>
      <div class="col-12 text-center">
        <button type="submit" class="primary-btn submitButton">Submit
          <i class="fa fa-check ml-2"></i>
        </button>
      </div>
    </form>
  </div>

